import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
            loading: false,
        };
    },

    methods: {
        setLoading(loading: boolean) {
            this.loading = loading;
        },
    },
});
